import React from 'react';
import FollowList from './FollowList.js';

const FollowingPage = () => {
  return (
    <div>
      <FollowList listType="following" />
    </div>
  );
};

export default FollowingPage;
